import React, { useState, useEffect } from "react"

import Box from "@mui/material/Box";
import List from "@mui/material/List";
import Stack from "@mui/material/Stack";
import Drawer from "@mui/material/Drawer";
import { useDispatch } from "react-redux";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";

import { MuiAvatar } from "../MuiAvatar"
import { WEB_URL } from "../../api/URLs";
import MenuOptionItem from "./MenuOptionItem";
import { userActions } from "../../store/actions";
import { UserService } from "../../services/storage.service";
import { MixPanelTrackedLink } from "../MixPaneTrackedLink";
import { StyledHeader } from "../StyledComponents/HeaderStyles";
import { GTM_EVENTS, PROFILE_TABS, S3_BUCKET } from "../../constants"
import { AddIcon, GiftIcon, HamburgerIcon, KeyIcon, LoginIcon, LogoutIcon, ProfileIcon, SearchIcon, TCFLogo, TCFWhiteLogo, UserGroupIcon } from "../Icons";

export function HeaderMobile() {

    const dispatch = useDispatch();
    const { SETTINGS } = PROFILE_TABS;
    const [userData, setUserData] = useState({});
    const [logoUrl, setLogoUrl] = useState(null);
    const [menuOptions, setMenuOptions] = useState([
        { gtmEvent: GTM_EVENTS.START_FUNDRAISER_CLICKED, label: "START A FUNDRAISER", url: WEB_URL.CREATE_FUNDRAISER, icon: <AddIcon /> },
        { gtmEvent: GTM_EVENTS.SUPPORT_FUNDRAISER_CLICKED, label: "SUPPORT A FUNDRAISER", url: WEB_URL.FUNDRAISER_LISTING, icon: <GiftIcon /> },
        { label: "ABOUT US", url: WEB_URL.ABOUT_US, icon: <UserGroupIcon /> }
    ]);

    const logOut = () => {
        dispatch(userActions.logout())
    }

    useEffect(() => {
        if (window.location.pathname == "/" || window.location.pathname.split('/')[1] == "campaign")
            setLogoUrl(TCFWhiteLogo);

        else setLogoUrl(TCFLogo);

        if (UserService.isLoggedIn()) {
            setUserData(UserService.getUser());

            setMenuOptions([
                { label: "MY PROFILE", url: WEB_URL.PROFILE(SETTINGS), icon: <ProfileIcon /> },
                { label: "MY ACCOUNT", url: WEB_URL.PROFILE(), icon: <KeyIcon /> },
                ...menuOptions,
                { label: "LOGOUT", onClick: logOut, icon: <LogoutIcon /> }
            ])
        }

        else setMenuOptions([{ label: "LOGIN", url: WEB_URL.LOGIN, icon: <LoginIcon /> }, ...menuOptions]);

    }, [])

    const [openSideMenu, setOpenSideMenu] = useState(false);

    return <StyledHeader>
        <Stack className="HeaderMainStack">
            <Container className="HeaderContainer">
                <Stack flexDirection={"row"} justifyContent={"space-between"}>

                    <MixPanelTrackedLink type="link" label="none" context="Logo icon in header" href="/" underline="none" color="inherit">
                        <img src={logoUrl} className="tcfLogo" />
                    </MixPanelTrackedLink>

                    <Stack className="HeaderRightStack">

                        <MixPanelTrackedLink type="iconButton" label="none" context="Search icon on header" href={WEB_URL.FUNDRAISER_LISTING} color="inherit">
                            <SearchIcon width={17} />
                        </MixPanelTrackedLink>

                        <IconButton onClick={() => setOpenSideMenu(true)}>
                            <HamburgerIcon width={30} />
                        </IconButton>

                        <Drawer anchor={"right"} open={openSideMenu} onClose={() => setOpenSideMenu(false)}>
                            <Box role="presentation">
                                <List>
                                    {
                                        Object.keys(userData).length ?
                                            <MenuOptionItem
                                                details={{
                                                    label: userData.first_name,
                                                    url: WEB_URL.PROFILE(SETTINGS),
                                                    icon: <MuiAvatar
                                                        variant="rounded"
                                                        sx={{ width: '34px', height: '34px' }}
                                                        src={S3_BUCKET + userData.avatar}
                                                        fullName={userData.first_name + " " + userData.last_name}
                                                    />
                                                }} /> :
                                            null
                                    }

                                    {menuOptions.map((menu, index) => (
                                        <MenuOptionItem details={menu} key={index} />
                                    ))}

                                </List>
                            </Box>
                        </Drawer>
                    </Stack>
                </Stack>
            </Container>
        </Stack>
    </StyledHeader>
}